import { gql } from '@apollo/client';
import { AccountListInfoShared } from '../fragments';

export default gql`
  query accountsChewy(
    $createdAtStart: String
    $createdAtEnd: String
    $updatedAtStart: String
    $updatedAtEnd: String
    $limit: Int
    $offset: Int
  ) {
    accountsChewy(
      createdAtStart: $createdAtStart
      createdAtEnd: $createdAtEnd
      updatedAtStart: $updatedAtStart
      updatedAtEnd: $updatedAtEnd
      limit: $limit
      offset: $offset
    ) {
      ...AccountListInfoShared
    }
  }
  ${AccountListInfoShared}
`;
